import { useContext } from 'react'
import { useRouter } from 'next/router'
import styled, { css } from 'styled-components'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'
import AnswerCountingInfoDesktop from './AnswerCountingInfo.desktop'

const TentativeScoringDetailInfoDesktop = () => {
  const { examGradingResultData } = useContext(
    PredictionOfPassedContainerContext,
  )
  const router = useRouter()

  const isGsat2025SecondRoute = router.pathname === '/prediction/gsat2025-2'

  const correctCount = examGradingResultData?.viewerResult.correctCount || 0
  const answeredCount = examGradingResultData?.viewerResult.answeredCount || 0

  const avgCorrectRate = answeredCount
    ? Math.round((correctCount / answeredCount) * 100)
    : 0

  return (
    <StyledWrapper>
      <AnswerCountingInfoDesktop />
      <div className="percent-box">
        <p>정답률</p>
        <strong>{avgCorrectRate}%</strong>

        {isGsat2025SecondRoute && (
          <p className="correct-rate-guide-text">
            ⓘ 정답률은 맞은 문항 수 / 푼 문항 수를 백분율로 나타낸 값입니다.
          </p>
        )}
      </div>
    </StyledWrapper>
  )
}

export default TentativeScoringDetailInfoDesktop

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: end;

  > .percent-box {
    width: 342px;
    height: 150px;
    border-radius: 10px;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 7px;

    > p {
      font-size: 18px;
      font-weight: 500;
      letter-spacing: -0.72px;
      color: #333;
    }

    > strong {
      font-size: 32px;
      font-weight: bold;
      letter-spacing: -1.28px;
      text-align: left;
      color: #004eff;
    }

    .correct-rate-guide-text {
      ${({ theme }) => css`
        font-size: 12px;
        color: ${theme.color.text_2};
      `}
    }
  }
`
